import { createApp } from 'vue';
import App from "@/App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import { createPinia } from 'pinia';
import '@mdi/font/css/materialdesignicons.css';

const pinia = createPinia();
const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(pinia);

// Handle redirect parameter from 404.html fallback
router.isReady().then(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectPath = urlParams.get('redirect');
  if (redirectPath) {
    router.replace(redirectPath);
  }
});

// Register service worker for caching
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

app.mount('#app');